import { SYS_CODE } from "./contrains";

//左邊補0
export function padLeft(str, len) {
  if (str.length >= len) return str;
  else return padLeft("0" + str, len);
}

// 右邊補0
export function padRight(str, len) {
  if (str.length >= len) return str;
  else return padRight(str + "0", len);
}

// 取得使用者作業平台
export function usrPlatform() {
  const ua = navigator.userAgent.toLowerCase();
  const testUa = (regexp) => regexp.test(ua);
  const testVs = (regexp) =>
    ua
      .match(regexp)
      .toString()
      .replace(/[^0-9|_.]/g, "")
      .replace(/_/g, ".");

  let system = "unknow";
  if (testUa(/windows|win32|win64|wow32|wow64/g)) {
    system = "windows"; // windows
  } else if (testUa(/macintosh|macintel/g)) {
    system = "macos"; // macos
  } else if (testUa(/x11/g)) {
    system = "linux"; // linux
  } else if (testUa(/android|adr/g)) {
    system = "android"; // android
  } else if (testUa(/ios|iphone|ipad|ipod|iwatch/g)) {
    system = "ios"; // ios
  }

  let systemVs = "unknow";
  if (system === "windows") {
    if (testUa(/windows nt 5.0|windows 2000/g)) {
      systemVs = "2000";
    } else if (testUa(/windows nt 5.1|windows xp/g)) {
      systemVs = "xp";
    } else if (testUa(/windows nt 5.2|windows 2003/g)) {
      systemVs = "2003";
    } else if (testUa(/windows nt 6.0|windows vista/g)) {
      systemVs = "vista";
    } else if (testUa(/windows nt 6.1|windows 7/g)) {
      systemVs = "7";
    } else if (testUa(/windows nt 6.2|windows 8/g)) {
      systemVs = "8";
    } else if (testUa(/windows nt 6.3|windows 8.1/g)) {
      systemVs = "8.1";
    } else if (testUa(/windows nt 10.0|windows 10/g)) {
      systemVs = "10";
    }
  } else if (system === "macos") {
    systemVs = testVs(/os x [\d._]+/g);
  } else if (system === "android") {
    systemVs = testVs(/android [\d._]+/g);
  } else if (system === "ios") {
    systemVs = testVs(/os [\d._]+/g);
  }
  // 平台
  let platform = "unknow";
  if (system === "windows" || system === "macos" || system === "linux") {
    platform = "desktop"; // 桌面端
  } else if (system === "android" || system === "ios" || testUa(/mobile/g)) {
    platform = "mobile"; // 移动端
  }
  // 内核和载体
  let engine = "unknow";
  let supporter = "unknow";
  if (testUa(/applewebkit/g)) {
    engine = "webkit"; // webkit内核
    if (testUa(/edge/g)) {
      supporter = "edge"; // edge浏览器
    } else if (testUa(/opr/g)) {
      supporter = "opera"; // opera浏览器
    } else if (testUa(/chrome/g)) {
      supporter = "chrome"; // chrome浏览器
    } else if (testUa(/safari/g)) {
      supporter = "safari"; // safari浏览器
    } else if (testUa(/crios/g)) {
      supporter = "chrome_mobile"; // chrome浏览器
    }
  } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
    engine = "gecko"; // gecko内核
    supporter = "firefox"; // firefox浏览器
  } else if (testUa(/presto/g)) {
    engine = "presto"; // presto内核
    supporter = "opera"; // opera浏览器
  } else if (testUa(/trident|compatible|msie/g)) {
    engine = "trident"; // trident内核
    supporter = "iexplore"; // iexplore浏览器
  }
  // 内核版本
  let engineVs = "unknow";
  if (engine === "webkit") {
    //  engineVs = testVs(/applewebkit\/[\d._]+/g);
  } else if (engine === "gecko") {
    //  engineVs = testVs(/gecko\/[\d._]+/g);
  } else if (engine === "presto") {
    //  engineVs = testVs(/presto\/[\d._]+/g);
  } else if (engine === "trident") {
    // engineVs = testVs(/trident\/[\d._]+/g);
  }
  // 载体版本
  let supporterVs = "unknow";
  if (supporter === "chrome") {
    // supporterVs = testVs(/chrome\/[\d._]+/g);
  } else if (supporter === "chrome_mobile") {
    // supporterVs = testVs(/crios\/[\d._]+/g);
  } else if (supporter === "safari") {
    // supporterVs = testVs(/version\/[\d._]+/g);
  } else if (supporter === "firefox") {
    // supporterVs = testVs(/firefox\/[\d._]+/g);
  } else if (supporter === "opera") {
    //  supporterVs = testVs(/opr\/[\d._]+/g);
  } else if (supporter === "iexplore") {
    // supporterVs = testVs(/(msie [\d._]+)|(rv:[\d._]+)/g);
  } else if (supporter === "edge") {
    // supporterVs = testVs(/edge\/[\d._]+/g);
  }

  let shell = "none";
  let shellVs = "unknow";
  if (testUa(/micromessenger/g)) {
    shell = "wechat";
    // shellVs = testVs(/micromessenger\/[\d._]+/g);
  } else if (testUa(/qqbrowser/g)) {
    shell = "qq";
    //  shellVs = testVs(/qqbrowser\/[\d._]+/g);
  } else if (testUa(/ucbrowser/g)) {
    shell = "uc";
    //  shellVs = testVs(/ucbrowser\/[\d._]+/g);
  } else if (testUa(/qihu 360se/g)) {
    // shell = "360";
  } else if (testUa(/2345explorer/g)) {
    shell = "2345";
    // shellVs = testVs(/2345explorer\/[\d._]+/g);
  } else if (testUa(/metasr/g)) {
    shell = "sougou";
  } else if (testUa(/lbbrowser/g)) {
    shell = "liebao";
  } else if (testUa(/maxthon/g)) {
    shell = "maxthon";
    //  shellVs = testVs(/maxthon\/[\d._]+/g);
  }
  return Object.assign(
    {
      engine, // webkit gecko presto trident
      engineVs,
      platform, // desktop mobile
      supporter, // chrome safari firefox opera iexplore edge
      supporterVs,
      system, // windows macos linux android ios
      systemVs,
    },
    shell === "none"
      ? {}
      : {
          shell, // wechat qq uc 360 2345 sougou liebao maxthon
          shellVs,
        }
  );
}

// 取得使用者地理位置
export function usrLocation(options) {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  );
}

// 取得使用者角色(內部)
export function usrRole(role) {
  var result = "NORMAL";
  switch (SYS_CODE) {
    case "RTS":
      switch (role) {
        case "RTS00":
          result = "EXECUTIVE";
          break;
        case "RTS01":
          result = "WORK";
          break;
        case "RTS02":
          result = "TEACHER";
          break;
        case "RTS03":
          result = "SELF"; //
          break;
        default:
          result = "STUDENT";
      }
      return result;
    case "AFS":
      switch (role) {
        case "AFS01":
          result = "STUDENT"; // 一般申請角色
          break;
        case "AFS02":
          result = "WORKMANAGER"; // 業務管理角色
          break;
        case "AFS03":
          result = "SELF"; //
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "APC":
      switch (role) {
        case "APC00":
          result = "MANAGER"; // 一般申請角色
          break;
        case "APC01":
          result = "TEACHER"; // 教職員
          break;
        case "APC02":
          result = "STUDENT"; // 學生
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "NMS":
      switch (role) {
        case "NMS01":
          result = "SYSMANAGER"; // 系統管理角色
          break;
        case "NMS02":
          result = "TEACHER"; // 老師角色
          break;
        case "NMS03":
          result = "STUDENT"; // 學生角色
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "PIM":
      switch (role) {
        case "PIM01":
          result = "STAFF"; // 一般職員工
          break;
        case "PIM02":
          result = "UNITB"; // 單位二級主管
          break;
        case "PIM03":
          result = "UNITC"; // 單位一級主管
          break;
        case "PIM04":
          result = "POFFICEA"; // 人事室承辦人
          break;
        case "PIM05":
          result = "POFFICEB"; // 人事室二級主管
          break;
        case "PIM06":
          result = "POFFICEC"; // 人事室一級主管(主任)
          break;
        case "PIM07":
          result = "MANGER"; // 系統管理者
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "SMS":
      switch (role) {
        case "SMS01":
          result = "SYSMANAGER"; // 系統管理角色
          break;
        case "SMS02":
          result = "DEPART"; // 部門管理角色
          break;
        case "SMS03":
          result = "SELF"; // 個人公告角色
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "SSP":
      switch (role) {
        case "SSP01":
          result = "SYSMANAGER"; //系統管理角色
          break;
        case "SSP02":
          result = "WORKMANAGER"; //業務管理角色(召策中心)
          break;
        case "SSP03":
          result = "DEAN"; //院長
          break;
        case "SSP04":
          result = "CHAIR"; //系主任 | 系所規劃者
          break;
        case "SSP05":
          result = "VIEWER"; // 負責人
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "HSS":
      switch (role) {
        case "HSS01":
          result = "SYSMANAGER"; // 系統管理
          break;
        case "HSS02":
          result = "WORKMANAGER"; // 人事室
          break;
        case "HSS03":
          result = "SECRETARY"; // 秘書室
          break;
        case "HSS04":
          result = "CHAIR"; // 一二級主管
          break;
        case "HSS05":
          result = "VIEWER"; // 個人
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "GSM":
      switch (role) {
        case "GSM01":
          result = "SYSMANAGER"; //系統管理角色
          break;
        case "GSM02":
          result = "WORKMANAGER"; //業務管理角色
          break;
        case "GSM03":
          result = "GATEA"; //第一校門管理者
          break;
        case "GSM04":
          result = "GATEB"; //第二校門管理者
          break;
        case "GSM05":
          result = "SIGNER"; //進出登記人員
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "TQA":
      switch (role) {
        case "TQA10":
          result = "TEACHER"; //教職員
          break;
        case "TQA03":
          result = "QAOFFICER"; //品管老師
          break;
        case "TQA04":
          result = "SECRETARY"; //院書記
          break;
        case "TQA05":
          result = "CHAIR"; //系主任
          break;
        case "TQA06":
          result = "DIRECTOR"; //中心主任
          break;
        case "TQA07":
          result = "DEAN"; //院長
          break;
        case "TQA02":
          result = "WORKMANAGER"; //業務管理
          break;
        case "TQA01":
          result = "SYSMANAGER"; //系統管理
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "RNS":
      switch (role) {
        case "RNS01":
          result = "MANAGER";
          break;
        case "RNS02":
          result = "UNDERTAKER";
          break;
        case "RNS05":
          result = "OPERATOR";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "GAM":
      switch (role) {
        case "GAM01":
        case "GAM02":
          result = "MANAGER"; //管理者
          break;
        case "GAM03":
          result = "INTERVIEWER"; //電訪員
          break;
        case "GAM04":
          result = "CHAIR"; //系主任
          break;
        case "GAM05":
          result = "ALUMNI"; //畢業生
          break;
        case "GAM06":
          result = "TUTOR"; //導師
          break;

        default:
          result = "NORMAL";
      }
      return result;
    case "GQM":
      switch (role) {
        case "GQM01":
        case "GQM02":
          result = "MANAGER"; //管理者
          break;
        case "GQM03":
          result = "TUTOR"; //導師
          break;
        case "GQM04":
          result = "INTERVIEWER"; //電訪員
          break;
        case "GQM05":
          result = "ALUMNI"; //畢業生
          break;
        case "GQM06":
          result = "CHAIR"; //系主任
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "AMS":
      switch (role) {
        case "AMS01":
        case "AMS02":
          result = "MANAGER";
          break;
        case "AMS03":
          result = "ASSOCIATION";
          break;
        case "AMS04":
          result = "ALUMNI";
          break;
        case "AMS05": //院長
          result = "DEAN";
          break;
        case "AMS06": //系主任
          result = "CHAIR";
          break;
        case "AMS07": //系辦
          result = "EXECUTIVEOFFICER";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "ARS":
      switch (role) {
        case "ARS01":
        case "ARS02":
          result = "MANAGER";
          break;
        case "ARS05":
          result = "GRADUATE";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "SLM":
      switch (role) {
        case "SLM01":
        case "SLM02":
          result = "MANAGER";
          break;
        case "SLM04":
          result = "TUTOR";
          break;
        case "SLM03":
          result = "INSTRUCTOR";
          break;
        case "SLM05":
          result = "STUDENT";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "ECA":
      switch (role) {
        case "ECA01":
        case "ECA02":
          result = "MANAGER";
          break;
        case "ECA03":
          result = "TEACHER";
          break;
        case "ECA04":
          result = "STUDENT";
          break;
        case "ECA05":
          result = "CHECKER";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "ILA":
      switch (role) {
        case "ILA01":
          result = "SYSMANAGER";
          break;
        case "ILA02":
          result = "WORKMANAGER";
          break;
        case "ILA03":
          result = "TEACHER";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "CCW":
      switch (role) {
        case "CCW01":
          result = "MANAGER"; // 總管理者
          break;
        case "CCW02":
          result = "COURSE"; // 老師 / 老師個人作品管理
          break;
        case "CCW03":
          result = "STANDARD"; // 學生 / 老師個人作品管理
          break;
        case "CCW04":
          result = "PROXY"; // 工讀生代傳
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "EPS":
      switch (role) {
        case "EPS01":
          result = "MANAGER"; // 總管理者
          break;
        case "EPS02":
          result = "TEACHER"; // 教職員
          break;
        case "EPS03":
          result = "STUDENT"; // 學生
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "OSS":
      switch (role) {
        case "OSS01":
          result = "MANAGER";
          break;
        case "OSS02":
          result = "DEPARTMENT";
          break;
        case "OSS03":
          result = "PERSIONAL";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "LRS":
      switch (role) {
        case "LRS01":
          result = "ADMINISTRATOR";
          break;
        case "LRS03":
          result = "UNITMANAGER";
          break;
        case "LRS04":
          result = "WORKMANAGER";
          break;
        case "LRS05":
          result = "PERSIONAL";
          break;
        case "LRS06":
          result = "SECURITY";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "TMS":
      switch (role) {
        case "TMS01":
          result = "ADMINISTRATOR";
          break;
        case "TMS02":
          result = "MANAGER";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "CFS":
      switch (role) {
        case "CFS01":
          result = "ADMINISTRATOR";
          break;
        case "CFS02":
          result = "NORMAL";
          break;
        case "CFS03":
          result = "WORKMANAGER";
          break;
        case "CFS04":
          result = "MANUFACTURER";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "DSS":
      switch (role) {
        case "DSS00":
          result = "ADMINISTRATOR";
          break;
        case "DSS01":
          result = "PRESIDENT";
          break;
        case "DSS02":
          result = "EXECUTIVE";
          break;
        case "DSS03":
          result = "CHAIR";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "USM":
      switch (role) {
        case "USM00":
          result = "SYSMANAGER";
          break;
        case "USM01":
          result = "WORKMANAGER";
          break;
        case "USM02":
          result = "UNITMANAGER";
          break;
        case "USM03":
          result = "PERSIONAL";
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "CSLC": //徵稿
      switch (role) {
        case "CSLC00":
          result = "ADMINISTRATOR"; //網資中心
          break;
        case "CSLC01":
          result = "MANAGER"; // 管理者
          break;
        case "CSLC02":
          result = "JURY"; // 評委(審查團)
          break;
        case "CSLC03":
          result = "PARTICIPANT"; // 參賽者
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "CSLL": //投票抽獎
      switch (role) {
        case "CSLL00":
          result = "ADMINISTRATOR"; //網資中心
          break;
        case "CSLL01":
          result = "MANAGER"; // 管理者
          break;
        case "CSLL03":
          result = "VOTER"; // 投票人
          break;
        default:
          result = "NORMAL";
      }
      return result;
    case "CSLS": //抽獎
      switch (role) {
        case "CSLS00":
          result = "ADMINISTRATOR"; //網資中心
          break;
        case "CSLS01":
          result = "MANAGER"; // 管理者
          break;
        case "CSLS02":
          result = "DRAWER"; // 抽獎人
          break;
        case "CSLS03":
          result = "VOTER"; // 投票者
          break;
        default:
          result = "NORMAL";
      }
      return result;
    default:
      return result;
  }
}

// 取得使用者角色(外顯)
export function showRole(role) {
  var result = "";
  switch (SYS_CODE) {
    case "TQA":
      switch (role) {
        case "TQA10":
          result = "一般層級"; //教職員
          break;
        case "TQA03":
          result = "品管老師"; //品管老師
          break;
        case "TQA04":
          result = "院書記"; //院書記
          break;
        case "TQA05":
          result = "系主任"; //系主任
          break;
        case "TQA06":
          result = "中心主任"; //中心主任
          break;
        case "TQA07":
          result = "院長"; //院長
          break;
        case "TQA02":
          result = "教資中心"; //業務管理
          break;
        case "TQA01":
          result = "系統管理"; //系統管理
          break;
        default:
          result = "";
      }
      return result;
    default:
      return result;
  }
}
// GUID
export function _uuid() {
  var d = Date.now();
  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : r & (0x3 | 0x8)).toString(16);
  });
}

// 判斷字串是否為空白或是NULL
export function isNullorEmpty(str) {
  // eslint-disable-next-line valid-typeof
  if (typeof str === null) {
    return true;
  }
  if (str === "") return true;
  var regu = "^[ ]+$";
  var re = new RegExp(regu);
  return re.test(str);
}

// 分割
export function addspace(num, count) {
  var result = [],
    counter = 0;
  if (num != null) {
    num = (num || 0).toString().split("");
    for (var i = num.length - 1; i >= 0; i--) {
      counter++;
      result.unshift(num[i]);
      if (!(counter % count) && i !== 0) {
        result.unshift(" ");
      }
    }
  }
  return result.join("");
}

export function getSchoolAcademicYear() {
  var d = new Date();
  var nowYear = d.getFullYear() - 1911;
  var nowMonth = d.getMonth() + 1;
  var schoolYear = nowYear;
  if (nowMonth >= 8) {
    schoolYear = nowYear;
  } else if (nowMonth < 2) {
    schoolYear = nowYear - 1;
  } else {
    schoolYear = nowYear - 1;
  }
  return schoolYear;
}

export function getSchoolAcademicSemester() {
  var d = new Date();
  var nowMonth = d.getMonth() + 1;
  var schoolSemester = 1;
  if (nowMonth >= 8) {
    schoolSemester = "1";
  } else if (nowMonth < 2) {
    schoolSemester = "1";
  } else {
    schoolSemester = "2";
  }
  return schoolSemester;
}
//電子憑證
export function getEvoucher() {
  const formatDate = (current_datetime) => {
    const MM = formateNum(current_datetime.getMonth() + 1);
    const dd = formateNum(current_datetime.getDate());
    const hh = formateNum(current_datetime.getHours());
    const mm = formateNum(current_datetime.getMinutes());
    const ss = formateNum(current_datetime.getSeconds());
    const code = getRandom(1000, 9999);
    let formatted_date =
      current_datetime.getFullYear().toString().substr(2, 2) +
      MM +
      dd +
      "-" +
      hh +
      mm +
      ss +
      "-" +
      code;
    return formatted_date;
  };
  const formateNum = (num) => {
    if (num < 9) {
      num = "0" + num;
    }
    return num;
  };

  const getRandom = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  return formatDate(new Date());
}

export function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}
